export const DOMAIN = 'https://stackshare.io';
export const SIGN_IN_PATH = '/sign_in';
export const LIGHT = 'light';
export const DARK = 'dark';
